import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types"
//styles
import { Wrapper, Content } from "./SearchBar.styles";
//Image
import SearchIcon from "../../images/search-icon.svg";

const SearchBar = ({ setSearchTerm }) => {
    const [state, setState] = useState("");
    const initial = useRef(true)
     //initial.current === this will hold the property- true

    useEffect(() => {
      if (initial.current){
        initial.current = false
        return; // used to skip the initial render in the useEffect
      }
      const timer = setTimeout(() => {
        setSearchTerm(state)
      }, 600)

      return () => clearTimeout(timer)
    }, [setSearchTerm, state])

  return (
    <Wrapper>
      <Content>
        <img src={SearchIcon} alt="search-icon" />
        <input type="text" placeholder="Search Movie" onChange={(e) => setState(e.currentTarget.value)} value={state} />
      </Content>
    </Wrapper>
  );
};

SearchBar.propTypes = {
  setSearchTerm: PropTypes.func
}

export default SearchBar;
